module.exports = __webpack_public_path__ + "static/media/visa_website.3cc158c7.webp";